import './styles.styl';

export const side = {
	name: 'fab-side',
	variants: ['sub'],
	hiddenParts: [
		'secondaryText',
	],
};
